import ICONS from "../../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import ConfirmBtnAccCreation from "../../../../_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import GstDetails from "../../../../_utils/AccountCreationComponents/GstDetails";
import PanDetails from "../../../../_utils/AccountCreationComponents/PanDetails";
import ActiveInactiveAssociatePopup from "../../../../_utils/ActiveInactiveAssociatePopup";
import CommonAlertCard from "../../../../_utils/CommonAlertCard";
import CommonLayout from "../../../../_utils/CommonLayout";
import "./index.css";

const BeneficiaryAccountEditStepPAN = ({
  verifiedPan,
  handlePANChange,
  panDetails,
  panLookupData,
  panVerificationLoading,
  isLinkedAccount,
  alreadyLinked,
  payload,
  gstVerificationData,
  gstVerificationLoading,
  setShowPopup,
  GSTStatus,
  gstVerified,
  GSTLinked,
  handleGSTChange,
  accountActiveInactiveState,
  setAccountActiveInactiveState,
  currentAssociate,
  setCurrentAssociate,
  openAssociatePopup,
  setOpenAssociatePopup,
  showGSTLinkedAlert,
  confirmEnable,
  setIsUpdateEnabled,
  isUpdateEnabled,
  canConfirm,
  showGSTNotLinked,
  isGstnPresent,
  showDetail,
}) => {
  return (
    <>
      <CommonLayout>
        <div className="flex flex-col gap-gap-md">
          {(isLinkedAccount || alreadyLinked) && verifiedPan && (
            <CommonAlertCard
              texts={`Looks like this PAN is already linked to this account. Please change provided PAN details to proceed.`}
            />
          )}

          {showGSTLinkedAlert && (
            <CommonAlertCard
              title="Since PAN and GSTIN are linked"
              texts={[
                "To edit PAN, the associated GSTIN must also be provided.",
                "GSTIN can only be replaced with other GSTINs that are associated with the provided PAN.",
              ]}
            />
          )}

          <div>
            <div className="h-auto">
              <PanDetails
                verifiedPan={verifiedPan}
                verifyPANisLoading={panVerificationLoading}
                panNumber={payload.panNumber}
                handlePanChange={handlePANChange}
                panDetails={panDetails}
              />
            </div>

            <div
              className={`h-auto rounded-border-radius-md ${!verifiedPan ? "pointer-events-none cursor-not-allowed opacity-light-opacity" : "pointer-events-auto cursor-default opacity-base-opacity"}`}
            >
              <GstDetails
                GSTStatus={GSTStatus}
                gstVerified={gstVerified}
                beneVerifyGST={gstVerificationData}
                isGSTLoading={gstVerificationLoading}
                GSTLinked={GSTLinked}
                GstNumber={payload.gstin}
                setShowPopup={setShowPopup}
                handleChange={handleGSTChange}
                showGSTNotLinked={showGSTNotLinked}
                verifiedPan={verifiedPan}
                payload={payload}
                isGstnPresent={isGstnPresent}
              />
            </div>
          </div>
        </div>
        <div className="w-width-full flex-col h-auto relative">
          <div className="w-full flex flex-col flex-1">
            <div className="flex-1">
              {confirmEnable &&
                payload.panNumber?.length === GlobalConfiguration.panLength &&
                !showDetail &&
                !(isLinkedAccount || alreadyLinked) && (
                  <>
                    <ConfirmBtnAccCreation
                      type="remitter"
                      status={panLookupData?.status}
                      lookupNext={isUpdateEnabled}
                      GSTStatus={GSTStatus}
                      isConfirmed={isUpdateEnabled}
                      isGSTLoading={gstVerificationLoading}
                      isButtonDisabled={!canConfirm}
                      selected={ICONS?.SELECTED_WITH_GREEN_CIRCLE}
                      not_selected={ICONS?.NOT_SELECTED_WITH_GREY_CIRCLE}
                      handleClick={() => {
                        if (!canConfirm) return;
                        setIsUpdateEnabled(true);
                      }}
                      isRemitter={true}
                      subtext={
                        "Confirm and click ‘Update’ to add this account as an active account associated with the provided PAN."
                      }
                    />
                  </>
                )}
              <ActiveInactiveAssociatePopup
                flow={
                  verifiedPan === false
                    ? "defaultPan"
                    : (isLinkedAccount || alreadyLinked) && verifiedPan
                      ? "Existing"
                      : showDetail
                        ? "notFoundPan"
                        : !showDetail && verifiedPan
                          ? "Pan"
                          : "defaultPan"
                }
                dropDownNo={GlobalConfiguration.lengthCheckZero}
                ifsc={panLookupData?.beneficiary_accounts?.[0]?.ifsc_code}
                bank={panLookupData?.beneficiary_accounts?.[0]?.bank_acc_no}
                pan={payload.panNumber}
                accActiveInactiveState={accountActiveInactiveState}
                setAccActiveInactiveState={setAccountActiveInactiveState}
                currentAssociate={currentAssociate}
                setCurrentAssociate={setCurrentAssociate}
                openAssociatePopup={openAssociatePopup}
                setOpenAssociatePopup={setOpenAssociatePopup}
                currentRoute="beneAccount"
                panLength={payload.panNumber.length}
              />
            </div>
          </div>
        </div>
      </CommonLayout>
    </>
  );
};

export default BeneficiaryAccountEditStepPAN;
